import { useEffect } from 'react';

interface Props {
  src: string;
  filename: string;
  onClose: () => void;
}

export function ImagePreviewModal({ src, filename, onClose }: Props): JSX.Element {
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col bg-black/95"
      onClick={onClose}
    >
      {/* Header */}
      <div
        className="flex items-center justify-between px-4 py-3 shrink-0"
        onClick={(e) => e.stopPropagation()}
      >
        <span className="text-sm text-gray-300 truncate mr-4">{filename}</span>
        <div className="flex items-center gap-3 shrink-0">
          <a
            href={src}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-red-400 hover:text-red-300"
            onClick={(e) => e.stopPropagation()}
          >
            Open
          </a>
          <button
            className="text-gray-400 hover:text-white p-1 -mr-1 touch-manipulation"
            onClick={onClose}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      {/* Image */}
      <div
        className="flex-1 flex items-center justify-center overflow-hidden px-2 pb-4"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={src}
          alt={filename}
          className="max-w-full max-h-full object-contain rounded"
          style={{ touchAction: 'pinch-zoom' }}
        />
      </div>
    </div>
  );
}
